// actions.js
import {
  UPLOAD_DOCUMENT_REQUEST,
  UPLOAD_DOCUMENT_SUCCESS,
  UPLOAD_DOCUMENT_FAILURE,
  CLEAR_DOCUMENT_ERRORS,
  CLEAR_DOCUMENT_SUCCESS,
} from './actionTypes';

export const uploadDocumentRequest = (document, entity, config) => {
  return {
  type: UPLOAD_DOCUMENT_REQUEST,
  payload: {document, entity, config},
}};

export const uploadDocumentSuccess = (document) => ({
  type: UPLOAD_DOCUMENT_SUCCESS,
  payload: document,
});

export const uploadDocumentFailure = (error) => ({
  type: UPLOAD_DOCUMENT_FAILURE,
  payload: error,
});

export const clearDocumentErrors = () => ({
  type: CLEAR_DOCUMENT_ERRORS,
});

export const clearDocumentSuccess = () => ({
  type: CLEAR_DOCUMENT_SUCCESS,
});